import type { ReimbursementTotals } from '../types/domain'
import type { ReimbursementsPaginationState } from '../types/hooks'

/** Totals placeholder used before the first list response lands. */
export const EMPTY_TOTALS: ReimbursementTotals = {}

/** Pagination placeholder used before the first list response lands. */
export const EMPTY_PAGINATION: ReimbursementsPaginationState = { current: 1, last: 1, total: 0 }
